<div class="integration-imports-search">
  <i class="material-icons">search</i>
  <input matInput
         class="integration-imports-search-input"
         [placeholder]="'SEARCH' | translate"
         (ccDebounceValueChange)="addFilter($event.target.value)"/>
</div>

